import React, { useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import SingleOrderForm from './SingleOrderForm'
import BulkOrderForm from './BulkOrderForm'
import SuperAdminDash from './SuperAdminDash'
import ReviewTable from 'pages/comparable/ReviewTable'
import { useLocation } from 'react-router-dom'
import PreviewTable from 'pages/comparable/PreviewTable'
import IdentiAndMarketAreaAddForm from 'pages/comparable/IdentiAndMarketAreaAddForm'
import ReportCard from './ReportCard'
import ReportGeneration from './ReportGeneration'

const Sample = () => {
  
  return (
   <ReportGeneration/>
  )
}

export default Sample